/**
 * Product Card Inline
 * Handles inline product cards with native select dropdown and add to cart functionality
 */

if (!customElements.get('product-card-inline')) {
  class ProductCardInline extends HTMLElement {

    connectedCallback() {
      this.select = this.querySelector('[data-product-inline-select]');
      this.productForm = this.querySelector('product-form');

      if (!this.select || !this.productForm) return;

      this.select.addEventListener('change', () => this.updateFormFromSelect());

      // Set initial state
      this.updateFormFromSelect();
    }

    /**
     * Updates form inputs and button state when a variant is selected
     */
    updateFormFromSelect() {
      const selectedOption = this.select.options[this.select.selectedIndex];

      if (!selectedOption) return;

      const variantId = selectedOption.dataset.variantId;
      const variantAvailable = selectedOption.dataset.variantAvailable === 'true';
      const inventoryQuantity = selectedOption.dataset.inventoryQuantity || 0;

      const hiddenId = this.productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = this.productForm.querySelector('input[name="inventory_quantity"]');
      const addButton = this.productForm.querySelector('[data-product-inline-add]');

      if (!hiddenId || !addButton) return;

      // Update hidden inputs
      hiddenId.value = variantId || '';
      if (hiddenInventoryQty) hiddenInventoryQty.value = inventoryQuantity;

      // Update button state
      const shouldDisable = !variantId || !variantAvailable;
      addButton.toggleAttribute('disabled', shouldDisable);
    }
  }

  customElements.define('product-card-inline', ProductCardInline);
}
